import React, { useEffect, Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { PromptHomePage } from './pages/PromptHomePage';
import { PromptHomePageChat } from './pages/PromptHomePageChat';
import { CaseStudyUSBank } from './pages/CaseStudyUSBank';
import { CaseStudyCyberSecurity } from './pages/CaseStudyCyberSecurity';
import { CaseStudyAIComparison } from './pages/CaseStudyAIComparison';
import { CaseStudyCaseWestern } from './pages/CaseStudyCaseWestern';
import { CaseStudyAmira } from './pages/CaseStudyAmira';
import { PortfolioProvider, usePortfolio } from './context/PortfolioContext';
// Component to handle chat query parameter
function ChatQueryHandler({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const {
    openChatDrawer
  } = usePortfolio();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('chat') === 'open') {
      // Small delay to ensure page is loaded
      setTimeout(() => {
        openChatDrawer();
        // Track drawer open from query param
        if (typeof window !== 'undefined' && (window as any).gtag) {
          ;
          (window as any).gtag('event', 'chat_opened', {
            event_category: 'Chat',
            event_label: 'Query Parameter',
            source: 'url_param'
          });
        }
      }, 100);
    }
  }, [location.search, openChatDrawer]);
  return <>{children}</>;
}
// Redirect component for old AI mode
function AIPortfolioRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    // Redirect to traditional portfolio with chat open
    navigate('/portfolio/traditional?chat=open', {
      replace: true
    });
    // Track redirect
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('event', 'ai_mode_redirect', {
        event_category: 'Navigation',
        event_label: 'AI Mode to Chat Drawer',
        from: '/portfolio/ai'
      });
    }
  }, [navigate]);
  return null;
}
export function AppRouter() {
  return <HelmetProvider data-id="element-20" data-mp="3ijvadqv0nnuz">
      <Router data-id="element-21" data-mp="3nheq6v7d48p1">
        <PortfolioProvider data-id="element-22" data-mp="3ngvg20nyeolk">
          <Routes data-id="element-23" data-mp="3nhogkjwbkhv9">
            {/* Main portfolio - direct entry */}
            <Route path="/" element={<ChatQueryHandler data-id="element-25" data-mp="2ushjlpcik0c4">
                  <App data-id="element-26" data-mp="2utiu9spmaktb" />
                </ChatQueryHandler>} data-id="element-24" data-mp="3sghw0hv62iy2" />
            <Route path="/portfolio" element={<ChatQueryHandler data-id="element-28" data-mp="34qnjy2io8yev">
                  <App data-id="element-29" data-mp="34pm5do2g5tse" />
                </ChatQueryHandler>} data-id="element-27" data-mp="2zr12fgvt8w09" />
            <Route path="/portfolio/traditional" element={<ChatQueryHandler data-id="element-31" data-mp="2c2hwh808gvbc">
                  <App data-id="element-32" data-mp="2c16qd1jbfbh2" />
                </ChatQueryHandler>} data-id="element-30" data-mp="39hm1f5fec2jp" />

            {/* AI Portfolio view - REDIRECT to traditional with chat open */}
            <Route path="/portfolio/ai" element={<AIPortfolioRedirect data-id="element-34" data-mp="y5exfxyzkuue" />} data-id="element-33" data-mp="y6gkl0ta17sh" />

            {/* Legacy AI Portfolio (original search-based) - keep for reference */}
            <Route path="/portfolio/ai-legacy" element={<PromptHomePage data-id="element-36" data-mp="p4h4caq367ql" />} data-id="element-35" data-mp="u28xf82gvzwd" />

            {/* Case study routes */}
            <Route path="/case-study/amira" element={<CaseStudyAmira data-id="element-38" data-mp="k5484zdbrobc" />} data-id="element-37" data-mp="k65sxvk57p69" />
            <Route path="/case-study/us-bank" element={<CaseStudyUSBank data-id="element-40" data-mp="f7m85yhacjfh" />} data-id="element-39" data-mp="k89w2ba7wk5h" />
            <Route path="/case-study/cyber-security" element={<CaseStudyCyberSecurity data-id="element-42" data-mp="afb6aq2zinka" />} data-id="element-41" data-mp="f8nig0qh91w5" />
            <Route path="/case-study/ai-comparison" element={<CaseStudyAIComparison data-id="element-44" data-mp="6f0psjhkger6" />} data-id="element-43" data-mp="aej7l6e3c9ps" />
            <Route path="/case-study/case-western" element={<CaseStudyCaseWestern data-id="element-46" data-mp="3slz9gaeh50nb" />} data-id="element-45" data-mp="1g7k3d8its1k" />

            {/* Legacy routes - redirect to main portfolio */}
            <Route path="/original" element={<Navigate to="/" replace data-id="element-48" data-mp="3no77soo1205x" />} data-id="element-47" data-mp="3nn5ro5s5mnhc" />
            <Route path="/login" element={<Navigate to="/" replace data-id="element-50" data-mp="1rj7wly1dtxte" />} data-id="element-49" data-mp="3np8l6zsimyqt" />
            <Route path="/role-selection" element={<Navigate to="/" replace data-id="element-52" data-mp="1wj407w663n8f" />} data-id="element-51" data-mp="1rkja4pkmqjxp" />
            <Route path="/portfolio/hiring-manager" element={<Navigate to="/" replace data-id="element-54" data-mp="1htoamjidhnub" />} data-id="element-53" data-mp="1wkov5mwe986t" />
            <Route path="/portfolio/recruiter" element={<Navigate to="/" replace data-id="element-56" data-mp="1mqok74efl8q6" />} data-id="element-55" data-mp="1msj187ml0goz" />
            <Route path="/portfolio/hiring-manager-choice" element={<Navigate to="/" replace data-id="element-58" data-mp="1dsmiemmvic1u" />} data-id="element-57" data-mp="18sgqr6glspjr" />
            <Route path="/portfolio/recruiter-choice" element={<Navigate to="/" replace data-id="element-60" data-mp="ywwvmm9v5uw2" />} data-id="element-59" data-mp="1dq03u31kewa4" />
            <Route path="/portfolio/general" element={<Navigate to="/" replace data-id="element-62" data-mp="13vzz42a73t1x" />} data-id="element-61" data-mp="13tncvcxemwj2" />

            {/* Catch all - redirect to main portfolio */}
            <Route path="*" element={<Navigate to="/" replace data-id="element-64" data-mp="2y751725mvxf5" />} data-id="element-63" data-mp="2y7xy7besj8k3" />
          </Routes>
        </PortfolioProvider>
      </Router>
    </HelmetProvider>;
}